import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useAuth from "@/hooks/useAuth";
import placesApi from "@/api/placesApi";
import PlaceForm from "@/components/PlaceForm/PlaceForm";
import PlaceRequest from "@/model/PlaceRequest";

function CreatePlacePage() {
  const { t } = useTranslation();
  const { session } = useAuth();
  const navigate = useNavigate();

  if (!session) {
    return null;
  }

  const handleSubmit = async (request: PlaceRequest) => {
    await placesApi.createPlace(session.accessToken, request);
    navigate("/places", { replace: true });
  };

  return (
    <PlaceForm
      title={t("places.create.title")}
      submitLabel={t("places.create.submit")}
      onSubmit={handleSubmit}
    />
  );
}

export default CreatePlacePage;
